import { produce } from 'immer';
import { uniq } from 'lodash';

import { GRAPH_REQUEST, GRAPH_SUCCESS, GRAPH_FAIL } from './actions';

export const INITIAL_STATE = {
  loading: false,
  ids: [],
  byId: {},
  error: '',
};

export const productGraphReducer = (
  state = INITIAL_STATE,
  { type, payload }: any = {},
) =>
  produce(state, (draft) => {
    switch (type) {
      case GRAPH_REQUEST: {
        draft.loading = true;
        return draft;
      }

      case GRAPH_SUCCESS: {
        const { graph, id } = payload;
        draft.loading = false;
        draft.error = '';

        // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'any' is not assignable to parame... Remove this comment to see the full error message
        draft.ids.push(id);
        draft.ids = uniq(draft.ids);
        draft.byId[id] = graph;
        return draft;
      }

      case GRAPH_FAIL:
        draft.loading = false;
        draft.error = payload.error;
        return draft;

      default:
        return draft;
    }
  });
